<rid-demo-page [title]="'Sorteren'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Categoriseren" variant="PRIMARY" routerLink="categorise" />
  <rid-button class="w-full" content="Ja of nee" variant="PRIMARY" routerLink="yes-or-no" />
  <rid-button class="w-full" content="Odd-one-out" variant="PRIMARY" routerLink="odd-one-out" />
</rid-demo-page>
